<template>
  <div
    class="relative flex items-center gap-2 rounded-lg bg-white px-3 py-2"
    :class="fileClass"
    data-cy="uploaded-file-item"
  >
    <icon-base :icon="IconChatDocument" class="flex-shrink-0" />
    <span class="text-sm break-all text-gray-700">{{ file.name }}</span>
    <button
      class="absolute -top-1 -right-1"
      data-cy="remove-file-button"
      @click="emit('file:remove')"
    >
      <icon-base :icon="IconRemoveFile" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { storeToRefs } from "pinia";

import { useFiles } from "@/stores/ai/files";

import IconChatDocument from "@/components/icons/IconChatDocument.vue";
import IconRemoveFile from "@/components/icons/IconRemoveFile.vue";

const emit = defineEmits<{ "file:remove": [] }>();

const { file } = defineProps<{ file: File }>();

const aiFilesStore = useFiles();
const { invalidFiles, failedFiles } = storeToRefs(aiFilesStore);

const fileClass = computed(() =>
  failedFiles.value.has(file) || invalidFiles.value.has(file)
    ? "border border-red-500"
    : "border border-gray-200"
);
</script>
